module.exports = __webpack_public_path__ + "img/icon-form.bdf87a08.png";